import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { Button } from '@/components/shadcn/button'
import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { SheetTrigger } from '@/components/shadcn/sheet'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconUploadOutline } from '@icons/IconUploadOutline'
import { CellContext } from '@tanstack/react-table'
import { DataTableV2UploadFilesAction } from '../types'
import { UploadFilesActionSheet } from './UploadFilesActionSheet'

type UploadFilesMenuItemProps<T, V> = {
  action: DataTableV2UploadFilesAction
  info: CellContext<T, V>
  displayAs?: 'dropdown-item' | 'icon-button'
}

export function UploadFilesMenuItemV2<T, V>({
  action,
  info,
  displayAs = 'dropdown-item',
}: UploadFilesMenuItemProps<T, V>) {
  const isIconButton = displayAs === 'icon-button'
  const namespaceParam = action.parameterMappings?.namespace
  const mappedNamespace = namespaceParam ? (info.row.original as Record<string, unknown>)[namespaceParam] : undefined
  const uploadNamespace = typeof mappedNamespace === 'string' ? mappedNamespace.trim() : ''

  if (!namespaceParam) return null

  const trigger = isIconButton ? (
    <TooltipButton tooltip={action.label}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="size-6" disabled={action.isDisabled}>
          <DynamicIcon
            iconName={action.icon || ''}
            lazyLoad={false}
            fallback={<IconUploadOutline className="size-3" />}
          />
          <span className="sr-only">{action.label}</span>
        </Button>
      </SheetTrigger>
    </TooltipButton>
  ) : (
    <SheetTrigger asChild>
      <div onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={action.isDisabled}>
          <div className="flex items-center gap-2">
            <DynamicIcon
              iconName={action.icon || ''}
              lazyLoad={false}
              className="size-3"
              fallback={<IconUploadOutline className="size-3" />}
            />
            <span>{action.label}</span>
          </div>
        </DropdownMenuItem>
      </div>
    </SheetTrigger>
  )

  return <UploadFilesActionSheet action={action} uploadNamespace={uploadNamespace} trigger={trigger} />
}
